import { createContext } from "react";

const PropertyFormDescriptionContext = createContext();

export default PropertyFormDescriptionContext;